import {useLocalization} from 'localization';

export const useLoadingText = (translatedText?: string): string => {
  const {t} = useLocalization();

  const text = translatedText ? ` ${translatedText.toLowerCase()}` : '';

  return `${t('data.status.Loading')}${text}...`;
};
